import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07f388d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "modal-title space-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "카카오클립 안내", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kakao_wrapper_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "kakao-modal-body" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/assets/svg/klipxangel.svg" }),
    /*#__PURE__*/_createElementVNode("div", { class: "modal_margin" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "kakao_main_title" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "엔젤리그 클럽딜에 참여"),
        /*#__PURE__*/_createTextVNode("하시면,"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 디지털자산지갑 "),
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "카카오 클립(Klip)"),
        /*#__PURE__*/_createTextVNode("에"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "조합가입 증명카드"),
        /*#__PURE__*/_createTextVNode("가 발급됩니다."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "eb deep-blue" }, "조합설립 후 "),
        /*#__PURE__*/_createElementVNode("img", {
          src: "/assets/image/kakaotalk.png",
          srcset: "/assets/image/kakaotalk@2x.png 2x, /assets/image/kakaotalk@3x.png 3x",
          class: ""
        }),
        /*#__PURE__*/_createTextVNode(" 으로 전송되어요. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "modal_margin" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "kakao_main_title" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "카카오톡 > 전체서비스"),
        /*#__PURE__*/_createTextVNode("에서"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "[클립]"),
        /*#__PURE__*/_createTextVNode(" 선택 후 서비스 가입 ")
      ]),
      /*#__PURE__*/_createElementVNode("img", {
        style: {"margin-top":"10px","width":"100%"},
        src: "/assets/image/klip_1.png",
        srcset: "/assets/image/klip_1@2x.png 2x, /assets/image/klip_1@3x.png 3x",
        class: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "modal_margin" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "kakao_main_title" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "eb" }, "참여하신 조합"),
        /*#__PURE__*/_createTextVNode(" 가입 증명카드를 조합설립 후"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 1달 안에 전송받으실 수 있습니다. ")
      ]),
      /*#__PURE__*/_createElementVNode("img", {
        style: {"margin-top":"10px","width":"100%"},
        src: "/assets/image/klip_02.png",
        srcset: "/assets/image/klip_02@2x.png 2x, /assets/image/klip_02@3x.png 3x",
        class: ""
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "닫기")
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })
  ], 64))
}